import React, { useContext } from 'react';
import { AccordionContext, useAccordionToggle } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './Profile.css';

function ContextAwareToggle({ children, eventKey, callback, expandedIcon, collapsedIcon }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
      eventKey,
      () => callback && callback(eventKey),
    );
  
    const isCurrentEventKey = currentEventKey === eventKey;

    return (
      <div className="accordion-header-container" onClick={decoratedOnClick}>
          {isCurrentEventKey
            ? (expandedIcon || <FaChevronUp className="accordion-header-icon"/>)
            : (collapsedIcon || <FaChevronDown className="accordion-header-icon"/>) }
          {children}
      </div>
    );
  }
  export default ContextAwareToggle 